import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';

@Component({
  selector: 'gg-player-ui',
  templateUrl: './player-ui.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayerUiComponent implements OnInit {
  public isEmbeded$ = this.store.select(state => state.player.isEmbeded);
  public isSeekable$ = this.store.select(state => state.player.isSeekable);

  constructor(private store: Store) {
  }

  ngOnInit() {
  }

}
